var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.2
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#989898"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4533 27.9668C17.0216 24.8463 16.8057 23.286 17.4207 21.952C18.0356 20.618 19.3445 19.8071 21.9623 18.1853L23.538 17.2091C25.9152 15.7364 27.1039 15 28.4173 15C29.7307 15 30.9193 15.7364 33.2965 17.2091L34.8722 18.1853C37.49 19.8071 38.799 20.618 39.4138 21.952C40.0288 23.286 39.813 24.8463 39.3812 27.9668L39.0641 30.2593C38.5094 34.2679 38.2321 36.2721 36.8952 37.4694C35.5581 38.6667 33.5973 38.6667 29.6758 38.6667H27.1587C23.2372 38.6667 21.2764 38.6667 19.9394 37.4694C18.6024 36.2721 18.3251 34.2679 17.7705 30.2593L17.4533 27.9668Z",
    stroke: "#424242",
    strokeWidth: 2.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0032 31.5681C25.9708 32.314 27.1475 32.7514 28.4166 32.7514C29.6858 32.7514 30.8625 32.314 31.8301 31.5681",
    stroke: "#424242",
    strokeWidth: 2.75,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDashboard);
export default __webpack_public_path__ + "static/media/menu_dashboard.de7ccd31e297f4d5479a320389fbff0c.svg";
export { ForwardRef as ReactComponent };